import { BACKEND_ROOT } from 'configs/apis';

// TODO нужно переделать бекенд пути на манер фронтовых путей (классами с геттерами путей), т.к. много путей, которые из нескольких id склеиваются
const PATH = {
  tenant: {
    root: 'tenants',
  },
  orderLabel: {
    root: 'tenant-labels',
  },
  availableTeamResources: {
    root: 'availableTeamResources',
  },
  fundsTransaction: {
    root: 'funds-transactions',
  },
  client: {
    root: 'clients',
    orders: 'orders',
    brands: 'brands',
    review: 'review',
    comment: 'comment',
    problem: 'problem',
    acquiringSettings: 'acquiring-settings',
    services: 'services',
  },
  documentation: {
    root: 'documentation',
    schemas: 'schemas',
  },
  documentTemplate: 'document-templates',
  action: {
    root: 'actions',
    start: 'start',
    vx: 'vx',
    meta: 'meta',
  },
  common: {
    subEntity: 'sub',
    list: 'list',
    subscribeOnUpdates: 'subscribe',
    ids: 'ids',
  },
  auth: {
    root: 'auth',
    getCurrent: 'me',
    signin: 'login',
    resetPassword: 'reset-password',
    signout: 'logout',
    changeCredentials: 'change-login-creds',
    verifyCredentials: 'confirmation',
    profile: 'profile',
    changePassword: 'change-password',
    invitation: 'invitation',
    refreshToken: 'refresh-token',
    adfs: 'adfs',
  },
  contractSP: {
    root: 'contracts/sp',
  },
  contractPO: {
    root: 'contracts/po',
  },
  otp: {
    root: 'otp',
  },
  user: {
    root: 'user-profiles',
    notifications: 'notification-settings',
    managers: 'managers',
    technician: 'technician',
    order: 'order',
    calendar: 'calendar-slots',
    filters: 'filters-map',
    hiddenOrderView: 'hidden-orderView',
    allByPosition: 'all-by-position',
    techniciansByDepartments: 'technicians-by-department',
  },
  notifications: {
    root: 'tenants',
    notifications: 'notification-settings',
    managers: 'managers',
    technician: 'technician',
  },
  notificationTemplate: {
    root: 'notifications',
  },
  userEnterprise: {},
  userSP: {
    availability: 'availability',
  },
  price: {
    client: 'client-prices',
    technician: 'technician-prices',
    serviceProvider: 'service-provider-pricelists',
    platformOperator: 'platform-operator-pricelists',
    settings: 'settings',
    priceItem: 'prices',
    order: 'order',
    dictionaries: 'dictionaries'
  },
  service: {
    root: 'service-item',
    multiple: 'service-items',
  },
  technicianTeam: {
    root: 'technician-teams',
    calendar: 'calendar-slots',
    byDepartments: 'by-department',
  },
  serviceCategory: {
    root: 'service-category',
  },
  serviceCategoryGroup: {
    root: 'service-category-groups',
    export: 'export',
    import: 'import',
  },
  servicePackage: {
    root: 'service-package',
  },

  serviceSubscription: {
    root: 'svc-subscription',
    group: 'groups',
  },
  brand: {
    root: 'brands',
    brandForClientPage: 'clients/settings/order',
  },
  serviceProvider: {
    root: 'service-providers',
    invite: 'invite',
  },
  region: {
    root: 'regions',
  },
  shop: {
    root: 'shops',
  },
  call: {
    root: 'calls',
  },
  serviceOrdered: {
    root: 'service-item',
    payment: 'payment',
    decline: 'decline',
    accept: 'accept',
    discount: 'price/discount',
  },
  // Общие части путей для инвойсов
  invoice: {
    root: 'invoices',
    provider: 'provider',
    po: 'po',
    additionalTransactions: 'additional-transactions',
    orderTransactions: 'order-transactions',
    cancel: 'cancel',
    confirm: 'confirm',
    markAsPaid: 'mark-as-paid',
    shop: 'shop',
    payDate: 'pay-date',
    generate: 'generate',
    export: 'export',
    exportPeriod: 'exportPeriod',
    filterProviders: 'filter/invoice/providers',
    filterCustomers: 'filter/invoice/customers',
    invoiceProviders: 'invoice-providers',
    invoiceCustomers: 'invoice-customers',
    invoiceOrders: 'invoice-orders',
    invoiceAdditionalTransactions: 'invoice-additional-transactions',
  },
  invoiceProvider: {
    root: 'invoices/provider',
  },
  invoicePO: {
    root: 'invoices/po',
  },
  order: {
    archive: 'archive',
    customFields: 'custom-fields',
    root: 'orders',
    review: 'review',
    report: 'report',
    task: 'task',
    comments: 'comment',
    reviewComments: 'comment',
    follow: 'follow',
    followAll: 'followAll',
    assign: 'assign',
    distribution: 'distribution',
    offer: 'offer',
    filter: 'filter',
    balance: 'customer/balance',
    document: 'document',
    visitIntervals: 'visit-intervals',
    unarchive: 'unArchive',
    setTechnicianOnTheJob: 'setFlagOnTheJob',
    unsetTechnicianOnTheJob: 'unsetFlagOnTheJob',
    finalSketch: 'finalsketch',
    multiple: 'multiple',
    multipleByFilter: 'multiple-by-filter',
    rewardEstimate: 'rewardEstimate',
  },

  filter: {
    root: 'filter',
    order: 'order',
    archiveYears: 'archiveYears',
  },
  superAdmin: {
    root: 'super-admin',
    settings: 'settings',
    api: 'api',
  },
  enterprise: {
    root: 'enterprises',
    currency: 'currencies',
    ownServiceCompanies: 'own-sc',
    settings: 'settings',
    webhook: 'webhook',
    order: 'order',
    api: 'api',
  },
  enterpriseDepartment: {
    root: 'departments',
    unPaged: 'un-paged',
  },
  platformOperator: {
    root: 'platform-operator',
    currency: 'currencies',
    ownServiceCompanies: 'own-sc',
    settings: 'settings',
    webhook: 'webhook',
    order: 'order',
    api: 'api',
  },
  legalEntity: {
    root: 'legal-entities',
  },
  orderHistory: {
    root: 'order-history',
  },
  orderProviderTransaction: {
    root: 'transactions',
  },
  orderType: {
    root: 'order-types',
    default: 'default',
  },
  orderReportConfig: {
    root: 'order-report-config',
    default: 'default',
  },
  orderView: {
    root: 'order-views',
    priority: 'priority',
  },
  // serverEvent: {
  //   root: '/server-events',
  //   task: {
  //     root: '/task',
  //     all: '/all',
  //     order: '/order',
  //   },
  //   order: {
  //     root: '/order',
  //     all: '/all',
  //   },
  // },
  file: {
    root: 'file-storage',
  },
  notification: {
    root: 'notifications',
    urgent: 'urgent',
  },
  country: {
    root: 'countries',
  },
  promotionsConfig: {
    root: 'promotions/order',
    config: 'config',
    export: 'export',
    import: 'import',
  },
  dictionary: {
    root: 'dictionaries',
    wareCategory: 'wareCategories',
    measurementUnit: 'measurementUnits',
    contractType: 'contractTypes',
  },
  recommendationsConfig: {
    root: 'recommendations/order',
    config: 'config',
    forSession: 'session',
    export: 'export',
    import: 'import',
  },
  orderSession: {
    root: 'order-sessions',
    customer: 'customer',
    address: 'address',
    services: 'services',
    createOrder: 'create-order',
    cancelSession: 'cancel-session',
    generateOrderNumber: 'generate-order-number',
    generateOrderNumbers: 'generate-order-numbers',
  },
  releaseNotes: {
    root: 'release-notes',
  },
  route: {
    root: 'route',
  },
} as const;

export const PATH_BACKEND_PART = PATH;

export const PATH_BACKEND = {
  root: BACKEND_ROOT,
  country: {
    root: getFullPath(PATH.country.root),
  },
  distributionCity: {
    root: getFullPath(PATH.shop.root, 'city'),
  },
  task: {
    orderFilterUserRecipients: getFullPath(PATH.filter.root, PATH.filter.order, PATH.order.task, 'user-recipients'),
  },
  orderLabel: {
    root: getFullPath(PATH.orderLabel.root),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'tenant-labels'),
  },
  client: {
    root: getFullPath(PATH.client.root),
    order: getFullPath(PATH.client.root, PATH.client.orders),
    brand: getFullPath(PATH.client.root, PATH.client.brands),
    services: getFullPath(PATH.client.root, PATH.client.orders, PATH.client.services),
  },
  documentation: {
    root: getFullPath(PATH.documentation.root),
    schemas: getFullPath(PATH.documentation.root, PATH.documentation.schemas),
  },
  documentTemplate: {
    root: getFullPath(PATH.documentTemplate),
  },
  action: {
    root: getFullPath(PATH.action.root),
    start: getFullPath(PATH.action.root, PATH.action.start),
    vx: getFullPath(PATH.action.root, PATH.action.vx),
  },
  otp: {
    root: getFullPath(PATH.otp.root),
  },
  fundsTransaction: {
    root: getFullPath(PATH.fundsTransaction.root),
  },
  contractSP: {
    root: getFullPath(PATH.contractSP.root),
    accept: getFullPath(PATH.contractSP.root, 'sign'),
    suspend: getFullPath(PATH.contractSP.root, 'suspend'),
    resume: getFullPath(PATH.contractSP.root, 'resume'),
    resendInvite: getFullPath(PATH.contractSP.root, 'invite-resend'),
  },
  contractPO: {
    root: getFullPath(PATH.contractPO.root),
    accept: getFullPath(PATH.contractPO.root, 'sign'),
    suspend: getFullPath(PATH.contractPO.root, 'suspend'),
    resume: getFullPath(PATH.contractPO.root, 'resume'),
  },
  user: {
    root: getFullPath(PATH.user.root),
    notifications: getFullPath(PATH.user.root, PATH.user.notifications),
    disable: getFullPath(PATH.user.root, 'status'),
    all: getFullPath(PATH.user.root, 'all'),
    allByPositions: getFullPath(PATH.user.root, PATH.user.allByPosition),
    idNameOnly: getFullPath(PATH.user.root, 'allShort'),
  },
  notifications: {
    root: getFullPath(PATH.notifications.root),
    notifications: getFullPath(PATH.notifications.root, PATH.notifications.notifications),
    disable: getFullPath(PATH.notifications.root, 'status'),
    all: getFullPath(PATH.notifications.root, 'all'),
    idNameOnly: getFullPath(PATH.notifications.root, 'allShort'),
  },
  notificationTemplate: {
    root: getFullPath(PATH.notificationTemplate.root),
  },
  userEnterprise: {},
  userSP: {},
  auth: {
    root: getFullPath(PATH.auth.root),
    getCurrentUser: getFullPath(PATH.auth.root, PATH.auth.getCurrent),
    signin: getFullPath(PATH.auth.root, PATH.auth.signin),
    signout: getFullPath(PATH.auth.root, PATH.auth.signout),
    resetPassword: getFullPath(PATH.auth.root, PATH.auth.resetPassword),
    verifyCredentials: getFullPath(PATH.auth.root, PATH.auth.verifyCredentials),
    changeCredentials: getFullPath(PATH.auth.root, PATH.auth.changeCredentials),
    changePassword: getFullPath(PATH.auth.root, PATH.auth.changePassword),
    resendInvite: getFullPath(PATH.auth.root, PATH.auth.invitation),
    refreshToken: getFullPath(PATH.auth.root, PATH.auth.refreshToken),
    loginAdfs: getFullPath(PATH.auth.root, PATH.auth.signin, PATH.auth.adfs),
  },
  priceAny: {
    dictionaries: getFullPath(PATH.price.priceItem, PATH.price.order, PATH.price.dictionaries)
  }, 
  priceClient: {
    root: getFullPath(PATH.price.client),
  },
  priceTechnician: {
    root: getFullPath(PATH.price.technician),
  },
  priceServiceProvider: {
    root: getFullPath(PATH.price.serviceProvider),
  },
  pricelistServiceProvider: {
    root: getFullPath(PATH.price.serviceProvider),
  },
  pricelistPlatformOperator: {
    root: getFullPath(PATH.price.platformOperator),
  },
  technicianTeam: {
    root: getFullPath(PATH.technicianTeam.root),
  },
  platformOwnerService: {
    root: getFullPath(PATH.service.root),
  },
  platformOwnerServiceCategory: {
    root: getFullPath(PATH.serviceCategory.root, ''),
  },
  platformOwnerServiceCategoryGroup: {
    root: getFullPath(PATH.serviceCategoryGroup.root, ''),
    currency: getFullPath(PATH.serviceCategoryGroup.root, '', PATH.common.subEntity, ''),
  },
  enterpriseCustomService: {
    root: getFullPath(PATH.service.root),
  },
  enterpriseServiceCategoryNative: {
    root: getFullPath(PATH.serviceSubscription.root),
  },
  enterpriseServiceCategoryCustom: {
    root: getFullPath(PATH.serviceCategory.root, ''),
  },
  enterpriseServiceCategoryGroupCustom: {
    root: getFullPath(PATH.serviceCategoryGroup.root, ''),
  },
  enterpriseServiceCategoryGroupNative: {
    root: getFullPath(PATH.serviceSubscription.root, PATH.serviceSubscription.group),
  },
  // Общие пути для инвойсов
  invoice: {
    filterProviders: getFullPath(PATH.invoice.filterProviders),
    filterCustomers: getFullPath(PATH.invoice.filterCustomers),
  },
  invoiceProvider: {
    root: getFullPath(PATH.invoiceProvider.root),
  },
  invoicePO: {
    root: getFullPath(PATH.invoicePO.root),
    customersTenants: getFullPath(PATH.invoice.invoiceCustomers, PATH.invoice.po, 'tenants'),
  },
  orderHistory: {
    root: getFullPath(PATH.orderHistory.root),
  },
  brand: {
    root: getFullPath(PATH.brand.root),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'brands'),
  },
  serviceProvider: {
    root: getFullPath(PATH.serviceProvider.root),
    invite: getFullPath(PATH.serviceProvider.root, PATH.serviceProvider.invite),
    finishInvitation: getFullPath(PATH.serviceProvider.root, PATH.serviceProvider.invite, 'finish'),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'service-providers'),
  },
  call: {
    root: getFullPath(PATH.call.root),
  },
  shop: {
    root: getFullPath(PATH.shop.root),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'shops'),
  },
  region: {
    root: getFullPath(PATH.region.root),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'regions'),
  },
  order: {
    root: getFullPath(PATH.order.root),
    shortMap: getFullPath(PATH.order.root, 'short-map'),
    subscribeOnUpdates: getFullPath(PATH.order.root, PATH.common.subscribeOnUpdates),
  },
  filter: {
    root: getFullPath(PATH.filter.root),
  },
  tenant: {
    root: getFullPath(PATH.tenant.root),
  },
  superAdmin: {
    root: getFullPath(PATH.superAdmin.root),
  },
  enterprise: {
    root: getFullPath(PATH.enterprise.root),
    currency: getFullPath(PATH.enterprise.root, PATH.common.subEntity, PATH.enterprise.currency),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'owners'),
  },
  platformOperator: {
    root: getFullPath(PATH.platformOperator.root),
    currency: getFullPath(PATH.platformOperator.root, PATH.common.subEntity, PATH.platformOperator.currency),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'platform-operators'),
  },
  legalEntity: {
    root: getFullPath(PATH.legalEntity.root),
  },
  enterpriseDepartment: {
    root: getFullPath(PATH.enterpriseDepartment.root),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'departments'),
    unPaged: getFullPath(PATH.enterpriseDepartment.root, PATH.enterpriseDepartment.unPaged),
  },
  notification: {
    root: getFullPath(PATH.notification.root),
    urgent: getFullPath(PATH.notification.root, PATH.notification.urgent),
    markAsRead: getFullPath(PATH.notification.root, 'mark-as-read'),
    markAsDismissed: getFullPath(PATH.notification.root, 'mark-as-dismissed'),
    subscribeOnUpdates: getFullPath(PATH.notification.root, PATH.common.subscribeOnUpdates),
  },
  orderType: {
    root: getFullPath(PATH.orderType.root),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'types'),
    default: getFullPath(PATH.orderType.root, PATH.orderType.default),
  },
  orderReportConfig: {
    root: getFullPath(PATH.orderReportConfig.root),
    default: getFullPath(PATH.orderReportConfig.root, PATH.orderReportConfig.default),
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'reports'),
  },
  orderView: {
    root: getFullPath(PATH.orderView.root),
    priority: getFullPath(PATH.orderView.root, PATH.orderView.priority),
  },
  file: {
    root: getFullPath(PATH.file.root),
    anonymously: getFullPath(PATH.file.root, 'anonymous'),
  },
  customField: {
    orderFilter: getFullPath(PATH.order.filter, PATH.enterprise.order, 'custom-fields'),
  },
  serviceCategoryGroup: {
    root: getFullPath(PATH.serviceCategoryGroup.root),
  },
  serviceCategory: {
    root: getFullPath(PATH.serviceCategory.root),
  },
  servicePackage: {
    root: getFullPath(PATH.servicePackage.root),
  },
  service: {
    root: getFullPath(PATH.service.root),
  },
  // serverEvent: {
  //   root: fullPath(PATH.serverEvent),
  //   task: {
  //     root: fullPath(PATH.serverEvent, PATH.serverEvent.task.root),
  //     all: fullPath(PATH.serverEvent, PATH.serverEvent.task.root, PATH.serverEvent.task.all),
  //     order: fullPath(PATH.serverEvent, PATH.serverEvent.task.root, PATH.serverEvent.task.order),
  //   },
  //   order: {
  //     root: fullPath(PATH.serverEvent, PATH.serverEvent.order.root),
  //     all: fullPath(PATH.serverEvent, PATH.serverEvent.order.root, PATH.serverEvent.order.all),
  //   },
  // },
  promotionsConfig: {
    root: getFullPath(PATH.promotionsConfig.root, PATH.promotionsConfig.config),
  },
  dictionary: {
    root: getFullPath(PATH.dictionary.root),
    promotions: getFullPath(PATH.promotionsConfig.root, PATH.dictionary.root),
    recommendations: getFullPath(PATH.recommendationsConfig.root, PATH.dictionary.root),
    wareCategory: getFullPath(PATH.dictionary.root, PATH.dictionary.wareCategory),
    orderContractType: getFullPath(PATH.dictionary.root, PATH.dictionary.contractType),
    distributionCity: getFullPath(PATH.shop.root, 'city'),
    measurementUnits: getFullPath(PATH.dictionary.root, PATH.dictionary.measurementUnit),
  },
  recommendationsConfig: {
    root: getFullPath(PATH.recommendationsConfig.root, PATH.recommendationsConfig.config),
    session: getFullPath(PATH.recommendationsConfig.root, PATH.recommendationsConfig.forSession),
  },
  orderSession: {
    root: getFullPath(PATH.orderSession.root),
  },
  releaseNotes: {
    root: getFullPath(PATH.releaseNotes.root),
  },
  route: {
    root: getFullPath(PATH.route.root),
  },
};

function getFullPath(...path: string[]): string {
  return `${BACKEND_ROOT}/${path.join('/')}`;
}
